import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from "react-i18next";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

class SwipeBar extends React.Component {

  render() {
    const { t, classes, offsetPerc, containerWidth } = this.props;

    const paddingLeft = 40; //defined in css
    const paddingRight = 20; //defined in css

    const pos = ((containerWidth - (paddingLeft + paddingRight ) ) * offsetPerc / 100) + (paddingLeft / 2)  ;

    return (
      <div id="swipe-bar">
        <div className={classes.swipeContainer} title={t("map:swipe-tooltip")} style={{left: pos}}>
          <div className={ classes.swipeBar} />
        </div>
      </div>
    );
  }
}

SwipeBar.propTypes = {
  id: PropTypes.string.isRequired,
  offsetPerc: PropTypes.number,
  containerWidth: PropTypes.number
};

export default withNamespaces()(withStyles(mapStyle)(SwipeBar));